export default function Logo({ size = 48 }: { size?: number }) {
  return (
    <img
      src='/assets/logo.png'
      alt='LinguGeek logo'
      width={size}
      height={size}
      style={{ display: 'inline-block', objectFit: 'contain' }}
      draggable={false}
      sizes={`${size}px`}
    />
  );
}
